import { render } from "./ChatBaseLayout.vue?vue&type=template&id=fab9aea2"
import script from "./ChatBaseLayout.vue?vue&type=script&lang=js"
export * from "./ChatBaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script